module.exports = __webpack_public_path__ + "img/signup-empty.07cba79e.svg";